import { useState } from 'react';
import { Box, Flex } from 'reflexbox';

import { Heading, Paragraph, Radio } from '@treams/treams-ui';

import Azure from './Azure';
import Google from './Google';

function CreateIdentityProviderForm() {
	const [idp, setIdp] = useState<'azure' | 'google' | undefined>();

	return (
		<Box>
			<Box mb={3}>
				<Heading>1. Maak een keuze tussen Azure of Google Workspace</Heading>
				<Box mt={2}>
					<Flex>
						<Box mr={2}>
							<Radio.Card
								checked={idp === 'azure'}
								onChange={() => setIdp('azure')}
								title="Azure"
							/>
						</Box>
						<Radio.Card
							checked={idp === 'google'}
							onChange={() => setIdp('google')}
							title="Google Workspace"
						/>
					</Flex>
				</Box>
			</Box>
			{idp === undefined ? (
				<Box mb={3}>
					<Paragraph></Paragraph>
				</Box>
			) : idp === 'azure' ? (
				<Azure />
			) : (
				<Google />
			)}
		</Box>
	);
}

export default function IdentityProviders() {
	return <CreateIdentityProviderForm />;
}
